import React from 'react'
import './MediaPreview.css'
import MediaUpload from './MediaUpload'
import CanvasSubtitlePreview from './CanvasSubtitlePreview'
import SubtitleDownloadButton from './SubtitleDownloadButton'
import AudioPlayer from '../../../shared/components/ui/AudioPlayer'

/**
 * 미디어 프리뷰 컴포넌트 (Canvas 미리보기 전용)
 * 서버 drawtext 미리보기 제거 - Canvas만 사용
 */
function MediaPreview({ 
  section, 
  isConvertingMp4,
  isUploadingMedia,
  onFileUpload,
  onFileDrop,
  onRemove,
  onRemoveMedia,
  onAudioUpload,
  handleDragOver,
  subtitleSettings,
  titleSettings,
  videoSettings
}) {
  const handleVideoClick = (e) => {
    if (e.target.paused) {
      e.target.play()
    } else {
      e.target.pause()
    }
  }


  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <div className="timeline-media">
        <div className="media-controls">
        {(section.imageFile || section.mp4File) && (
          <SubtitleDownloadButton 
            section={section}
            subtitleSettings={subtitleSettings}
            titleSettings={titleSettings}
            videoSettings={videoSettings}
          />
        )}
        
        {/* X 버튼 - 이미지만 제거 */}
        {(section.imageFile || section.mp4File) && (
          <button 
            onClick={() => onRemoveMedia(section.id)}
            className="remove-button"
            title="이미지 제거"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="rgb(255 255 255 / 67%)"
            >
              <path d="M19,7a1,1,0,0,0-1,1V19.191A1.92,1.92,0,0,1,15.99,21H8.01A1.92,1.92,0,0,1,6,19.191V8A1,1,0,0,0,4,8V19.191A3.918,3.918,0,0,0,8.01,23h7.98A3.918,3.918,0,0,0,20,19.191V8A1,1,0,0,0,19,7Z"/>
              <path d="M20,4H16V2a1,1,0,0,0-1-1H9A1,1,0,0,0,8,2V4H4A1,1,0,0,0,4,6H20a1,1,0,0,0,0-2ZM10,4V3h4V4Z"/>
              <path d="M11,17V10a1,1,0,0,0-2,0v7a1,1,0,0,0,2,0Z"/>
              <path d="M15,17V10a1,1,0,0,0-2,0v7a1,1,0,0,0,2,0Z"/>
            </svg>
          </button>
        )}
      </div>
      
      {/* 미디어 업로드 중 스피너 표시 */}
      {isUploadingMedia && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 100,
          background: 'rgba(0, 0, 0, 0.8)',
          padding: '20px',
          borderRadius: '10px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px'
        }}>
          <div className="loading-spinner" style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f4f6',
            borderTopColor: '#3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
          <span style={{ color: 'white', fontSize: '14px' }}>업로드 중...</span>
        </div>
      )}
      
      {section.imageFile || section.mp4File || section.videoFile ? (
        <div className="media-preview-clean">
          {/* 원본 파일 우선 표시 (이미지/GIF) */}
          {section.imageFile ? (
            <div 
              className="image-preview-container" 
              style={{ 
                position: 'relative',
                width: '100%',
                height: '100%',
                borderRadius: '15px',
                overflow: 'hidden'
              }}
              onDragOver={handleDragOver}
              onDrop={(e) => {
                e.preventDefault()  // 기본 동작 방지
                e.stopPropagation()  // 상위 요소로 이벤트 전파 방지
                onFileDrop(e, section.id, 'image')
              }}
            >
              {/* Canvas 미리보기 - 항상 Canvas 사용 (자막/위치 조정 가능) */}
              <CanvasSubtitlePreview
                mediaFile={section.imageFile}
                mediaType="image"
                text={section.text || ''}
                settings={subtitleSettings}
                videoSettings={videoSettings}
                titleText={section.titleText || titleSettings?.text || ''}
                titleSettings={titleSettings}
                width={360}
                height={640}
              />
              
              {/* 이미지 오버레이 - image-preview-container 안으로 이동 */}
              {!section.mp4File && (
                <div className="image-overlay">
                  <div 
                    className="drop-zone-overlay"
                    onDragOver={handleDragOver}
                    onDrop={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      onFileDrop(e, section.id, 'image')
                    }}
                  >
                    새 이미지를 드래그하여 교체
                  </div>
                </div>
              )}
            </div>
          ) : section.mp4File ? (
            <div 
              className="video-preview-container"
              onDragOver={handleDragOver}
              onDrop={(e) => {
                e.preventDefault()  // 기본 동작 방지
                e.stopPropagation()  // 상위 요소로 이벤트 전파 방지
                onFileDrop(e, section.id, 'image')
              }}
            >
              {/* MP4 파일 Canvas 렌더링 */}
              <CanvasSubtitlePreview
                mp4Url={section.mp4File}
                mediaType="video"
                text={section.text || ''}
                settings={subtitleSettings}
                videoSettings={videoSettings}
                titleText={section.titleText || titleSettings?.text || ''}
                titleSettings={titleSettings}
                width={360}
                height={640}
              />
            </div>
          ) : null}
          
          {isConvertingMp4 && !section.mp4File && (
            <div className="conversion-overlay">
              <span>🎬 변환중...</span>
            </div>
          )}
        </div>
      ) : (
        <MediaUpload 
          section={section}
          onFileUpload={onFileUpload}
          onFileDrop={onFileDrop}
          handleDragOver={handleDragOver}
        />
      )}
      </div>
      
      {/* 음성 미리보기 또는 안내 메시지 */}
      {section.audioFile ? (
        <div style={{ 
          marginTop: '12px',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          <AudioPlayer 
            audioUrl={section.audioFile}
            onDelete={() => onAudioUpload(section.id, null)}
          />
        </div>
      ) : (
        <div style={{
          marginTop: '12px',
          padding: '14px',
          borderRadius: '8px',
          textAlign: 'center',
          color: '#ffffff',
          fontSize: '12px',
          fontWeight: '500',
          width: '100%',
          boxSizing: 'border-box'
        }}>
          음성을 생성하거나 업로드해주세요
        </div>
      )}
      
    </div>
  )
}

export default MediaPreview